module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/PenAndRuller-46a11c1531ea9805b475bd3a60cc794e.svg";